// extracted by mini-css-extract-plugin
module.exports = {"Link":"AutoLink_Link__gN_60"};